// ##### 25-04-30 Komarov
import parse from 'html-react-parser';
import uniqueId from 'lodash.uniqueid';
// ##### Komarov 2025-07-12
import React, { useEffect, useRef } from 'react';
import OutsideClickHandler from 'react-outside-click-handler';
// ##### 25-05-21 Komarov
import LocalizationNavLink from '../../../Library/Localization/LocalizationNavLink';

// ##### Komarov 2025-07-14
const RequestsMobile = ({
  pages,
  title,
  isWhiteLabelSet,
  companyCipher,
  sidebarListWidth,
}) => {
  const requestsRef = useRef();
  const requestsItemsRef = useRef();
  // ##### Komarov 2025-07-12
  useEffect(() => {
    requestsItemsRef.current.style.right = `${sidebarListWidth}px`;
    requestsItemsRef.current.style.top = `${requestsRef.current.offsetTop}px`;
  }, [sidebarListWidth]);

  const removeRequestsItems = () => {
    const requestsItemsclassList = requestsItemsRef.current.classList;
    if (!requestsItemsclassList.contains('RequestsMobileItemsHide')) {
      requestsItemsclassList.add('RequestsMobileItemsHide');
    }
  };

  const toggleRequestsItems = e => {
    requestsItemsRef.current.classList.toggle('RequestsMobileItemsHide');
    e.stopPropagation();
  };

  return (
    <OutsideClickHandler onOutsideClick={removeRequestsItems}>
      <a
        ref={requestsRef}
        role="button"
        data-component="Requests"
        onClick={toggleRequestsItems}
        onKeyDown={e => {
          if (e.key === 'Enter' || e.key === ' ') {
            toggleRequestsItems();
          }
        }}
      >
        {/* ##### 26-06-30 Komarov */}
        <h4>{typeof title === 'string' ? title : title?.[0]?.text ?? ''}</h4>
      </a>
      <div
        className="RequestsMobileItemsHide"
        data-component="RequestsMobileItems"
        ref={requestsItemsRef}
      >
        {pages.map(page => {
          return (
            // ##### 25-04-21 Komarov
            <LocalizationNavLink
              to={
                (isWhiteLabelSet &&
                  `/ref${companyCipher}/sitepages/?name=${page.name}&spid=${page.id}`) ||
                `/sitepages/?name=${page.name}&spid=${page.id}`
              }
              key={uniqueId()}
              onClick={removeRequestsItems}
            >
              {/* ##### 26-06-30 Komarov */}
              <h4>{parse(page.title?.[0]?.text ?? '')}</h4>
            </LocalizationNavLink>
          );
        })}
      </div>
    </OutsideClickHandler>
  );
};

export default RequestsMobile;
